import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enLang from './locales/en/en.json'
import frLang from './locales/fr/fr.json'
import LanguageDetector from 'i18next-browser-languagedetector'

const resources = {
  en: {
    // translation: {
    //     'landing.title': "Canada’s home for stablecoins"
    // }
    translation: enLang,
  },
  fr: {
    // translation: {
    //     'landing.title': "Le Canada, berceau des stablecoins"
    // }
    translation: frLang,
  },
}

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    lng: localStorage.getItem('lang') || 'en',
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
